import { colors, typography } from './tokens';

export default {
  colors,
  typography,
};
